import { DataType } from "../../../../form/typings";
import { styleControlOptions } from "../../../../form/component-schema";
export default {
    $id: "Modifier",
    type: DataType.Object,
    $ref: styleControlOptions.$id,
    properties: {
        widgetType: {
            type: DataType.String,
            title: "控件类型",
        },
        dataItemType: {
            type: DataType.String,
            title: "数据项类型",
        },
        mappings: {
            type: DataType.String,
            title: "映射关系",
        },
        labelVisible: {
            type: DataType.Boolean,
            title: "标题显示",
            default: true,
        },
    },
};
